<template>
  <div>
    <div class="page page__list" v-if="cur_form_val == 0">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sd_custname}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sd_date}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sd_custproddetail}}</p>
            <!-- <p class="list-item-muted">{{item.sd_date}}</p> -->
            <span
              class="list-item-status"
              :class="{'warning':item.sd_turnstatus=='待接收'}"
            >{{item.sd_turnstatus}}</span>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="cur_form_val == 1">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sa_custname}}</p>
            <p class="list-item-muted">{{item.sa_pocode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sa_custcontact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sa_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="cur_form_val == 2">
      <search-bar
        @search="search"
        name=""
        placeholder="客户PO/客户/型号/厂家/品牌/名称/规格"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.sa_custname}}</p>
            <p class="list-item-muted">{{item.sa_pocode}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.sa_custcontact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.sa_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="cur_form_val == 3">
      <search-bar
        @search="search"
        name=""
        placeholder="客户"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <div
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          @click="gotoView(item)"
        >
          <div class="weui-cell__bd">
            <p>{{item.cu_name}}</p>
            <p class="list-item-muted">{{item.pi_inoutno}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pi_contact}}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
          </div>
        </div>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>

    <div class="page page__list" v-if="cur_form_val == 4">
      <search-bar
        @search="search"
        name=""
        placeholder="客户/产品"
        ref="searchBar"
      />
      <filter-bar @change="search" :filters="filters" ref="filterBar" />
      <scroll-list @refresh="search">
        <router-link
          class="weui-cell weui-cell_access"
          v-for="item in items"
          :key="item.id"
          :to="'/b2b/out/'+item.id"
        >
          <div class="weui-cell__bd">
            <p>{{item.pi_custname}}</p>
            <p class="list-item-muted">{{item.pi_inoutno}}</p>
          </div>
          <div class="weui-cell__ft">
            <p>{{item.pr_detail }}</p>
            <p class="list-item-muted" v-format="'yyyy-MM-dd'">{{item.pi_date}}</p>
          </div>
        </router-link>
      </scroll-list>
      <div class="list-footer">
        <label class="list-footer__label">合计：{{items.length}}单</label>
      </div>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import FilterBar from "@/components/FilterBar.vue";
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    SearchBar,
    FilterBar,
    ScrollList,
  },
  data() {
    const me = this, beforeChange = me.beforeFormChange
    return {
      listUrls: [
        "/api/sale/saledown/osMakeList",
        "/api/sale/saledown/listData",
        "/api/sale/saledown/listData",
        "/api/storage/s2smapturn/osmakereturn/list",
        "/api/sale/prodinout/list"
      ],
      items: [],
      cur_form_val: 0,
      cur_status_val: -1,
      filters: [
        {
          type: "date",
          // name: "fa_date"
        },
        {
          type: "form",
          label: "单据名称",
          value: 0,
          beforeChange,
          options: [
            {
              value: 0,
              label: "客户外协订单"
            },
            {
              value: 1,
              label: "客户外协订单变更"
            },
            {
              value: 2,
              label: "外协订单取消"
            },
            {
              value: 3,
              label: "外协退货"
            },
            {
              value: 4,
              label: "送货单"
            }
          ]
        },
        {
          type: "status",
          label: "状态",
          value: 0,
          beforeChange: me.beforeStatusChange,
          options: [
            {
              value: 0,
              label: "全部"
            },
            {
              value: 1,
              label: "未接收"
            },
            {
              value: 2,
              label: "已接收"
            }
          ]
        }
      ]
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.search();
    });
  },
  methods: {
    beforeFormChange(filter, filterBar, next) {
      this.cur_form_val = filter.value

      if(this.cur_form_val == 1 || this.cur_form_val == 4) {
        this.filters.length = 2
      } else if( this.cur_form_val == 0) {
        this.filters[2] = {
          type: "status",
          label: "状态",
          value: 0,
          beforeChange: this.beforeStatusChange,
          options: [
            {
              value: 0,
              label: "全部"
            },
            {
              value: 1,
              label: "未接收"
            },
            {
              value: 2,
              label: "已接收"
            }
          ]
        }
      } else if( this.cur_form_val == 2 ) {
        this.filters[2] = {
          type: "status",
          label: "状态",
          value: 0,
          beforeChange: this.beforeStatusChange,
          options: [
            {
              value: 0,
              label: "未取消"
            },
            {
              value: 1,
              label: "已取消"
            }
          ]
        }
      } else if ( this.cur_form_val == 3 ) {
        this.filters[2] = {
          type: "status",
          label: "状态",
          value: 0,
          beforeChange: this.beforeStatusChange,
          options: [
            {
              value: 0,
              label: "未转销售退货"
            },
            {
              value: 1,
              label: "已转销售退货"
            }
          ]
        }
      }

      filterBar.initConfig()
      next()
    },
    beforeStatusChange(filter, filterBar, next) {
      this.cur_status_val = filter.value

      next()
    },
    search() {
      var me = this,
        cur_form_val = me.cur_form_val

      let filterBar = me.$refs.filterBar
      let dateFilter = me.$refs.filterBar.parsedFilters[0]
      let period = dateFilter.fn(dateFilter.value, dateFilter, filterBar).value.split(',')
      let fromDate = period[0].split(/-|\s|:/)
      let endDate = period[1].split(/-|\s|:/)

      let url = me.listUrls[cur_form_val]

      let keyword = me.$refs.searchBar.getValue()

      let params
      if(cur_form_val == 0) {
        params = {
          // pageNumber: 1,
          // pageSize: 16,
          fromDate: `${fromDate[0]}-${fromDate[1]}-${fromDate[2]} ${fromDate[3]}:${fromDate[4]}:${fromDate[5]}`,
          endDate: `${endDate[0]}-${endDate[1]}-${endDate[2]} ${endDate[3]}:${endDate[4]}:${endDate[5]}`,
          // page: 1,
          // start: 0,
          limit: 999999,
        }
        if(keyword) params.keyword = keyword
        if(me.cur_status_val > 0) params.isTurn = me.cur_status_val
      } else if (cur_form_val == 1) {
        fromDate[1]--
        endDate[1]--
        params = {
          category: 40,
          // pageNumber: 1
          // pageSize: 9999
          fromDate: new Date(...fromDate).getTime(),
          endDate: new Date(...endDate).getTime(),
          keyword,
          isTurn: 0,
          isCancel: 0,
          // page: 1,
          // start: 0,
          limit: 999999
        }
      } else if (cur_form_val == 2) {
        fromDate[1]--
        endDate[1]--
        params = {
          category: 60,
          fromDate: new Date(...fromDate).getTime(),
          endDate: new Date(...endDate).getTime(),
          keyword,
          isTurn: 0,
          isCancel:  me.cur_status_val > 0 ? 1 : 0,
          limit: 999999
        }
      } else if (cur_form_val == 3) {
        let s = me.cur_status_val > 0 ? " not" : ""
        params = {
          limit: 999999,
          condition: JSON.stringify([
            { 
              type: "string",
              field: "cu_name",
              operation: "like",
              value: keyword
            },
            {
              type: "date",
              field: "from_date",
              operation: "between",
              value: `${fromDate[0]}-${fromDate[1]}-${fromDate[2]} ${fromDate[3]}:${fromDate[4]}:${fromDate[5]},
                      ${endDate[0]}-${endDate[1]}-${endDate[2]} ${endDate[3]}:${endDate[4]}:${endDate[5]},`
            },
            {
              type: "condition",
              value: ` to_code is${s} null `
            }
          ])
        }
      } else if (cur_form_val == 4) {
        params = {
          caller: "b2bSaleDown",
          mode: "DETAIL",
          limit: 999999,
          condition: JSON.stringify([
            {
              type: "date",
              field: "pi_date",
              operation: "between",
              value: `${fromDate[0]}-${fromDate[1]}-${fromDate[2]} ${fromDate[3]}:${fromDate[4]}:${fromDate[5]},
                      ${endDate[0]}-${endDate[1]}-${endDate[2]} ${endDate[3]}:${endDate[4]}:${endDate[5]},`
            },
            {
              type: "condition",
              value: `pi_class='SALEOUT' `
            },
            {
              type: "condition",
              value:`(pi_custname like '%${keyword}%' or pr_detail like '%${keyword}%')`
            }
          ])
        }
      }

      me.$loading({
        url,
        params
      }).then(function (res) {
        if (res.success) {
          me.items = res.data.list || res.data || []
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    gotoView(item) {
      let name
      if(this.cur_form_val == 0)name = "B2BOsMakeOrder"
      if(this.cur_form_val == 1)name = "B2BOsMakeChange"
      if(this.cur_form_val == 2)name = "B2BOsMakeCancel"
      if(this.cur_form_val == 3)name = "B2BOsMakeReturn"
      
      this.$router.push({
        name,
        params: {
          initData: Object.assign({}, item),
        },
      });
    },
  }
}
</script>